import { Card, Icon } from "@atoms";
import { H1, Subtitle } from "@quarks";
import { Canvas, Fullbody, Heading } from "@templates";
import { Button, GroupAvatar } from "@molecules";
import { useNavigate, useParams } from "react-router-dom";
import { BreadCrumbs, useConnectBreadCrumbs } from "./BreadCrumbs";
import { Schedule } from "./components/Schedule";
import { useTranslation } from "react-i18next";
import { useAppSelector, getGroupById } from "@lib/store";
import { useConnectBasePath } from "@hooks";

type Props = {};

export const GroupsDetailPage = (props: Props) => {
  const { t } = useTranslation();
  const { groupId } = useParams();
  const group = useAppSelector(state => getGroupById(state, groupId || ""));
  const navigate = useNavigate();
  const connectBasePath = useConnectBasePath();

  const { paths } = useConnectBreadCrumbs();
  const goBackPath = paths.at(-2) ?? connectBasePath;

  const acceptedMembers = group?.members.filter(member => member.status === "Accepted") || [];

  return (
    group && (
      <>
        <Heading className="px-4 bg-beige-200 border-none justify-between">
          <div className=" col-span-full flex w-full grid-cols-2 justify-between items-center">
            <button
              onClick={() => {
                navigate(goBackPath);
              }}>
              <Icon
                icon="caretLeft"
                className="size-5"
              />
            </button>

            <button
              onClick={() => {
                navigate(`${connectBasePath}/groups/${group.id}/settings`);
              }}>
              <Icon
                icon="dotsHorizontal"
                className="size-5"
              />
            </button>
          </div>
        </Heading>
        <Canvas />
        <Fullbody className="sm:p-4 lg:p-8 md:py-14">
          <div className="md:flex justify-center flex-1">
            <div className="grid sm:gap-4 md:gap-[var(--gutterWidth)] grid-cols-1 sm:grid-cols-[minmax(0,var(--maxWidth))]">
              <BreadCrumbs className="hidden sm:flex" />

              <Card className="bg-beige-200 p-8 rounded-none sm:rounded-lg+ flex flex-col sm:grid sm:grid-cols-[auto_1fr_auto] justify-center sm:justify-start items-center gap-4">
                <GroupAvatar
                  group={group}
                  size="xlarge"
                />
                <div className="flex flex-col gap-1 items-center sm:items-start">
                  <H1 className=" col-span-full">{group.name}</H1>
                  <Subtitle className="text-mapiq-black-600">
                    {t("groups:Member", { count: acceptedMembers.length })}
                  </Subtitle>
                </div>
                <Button
                  className="self-start hidden sm:flex"
                  onClick={() => {
                    navigate(`${connectBasePath}/groups/${group.id}/settings`);
                  }}
                  button={"tertiary"}>
                  <Icon
                    icon="settings"
                    className="size-4"
                  />
                  {t("groups:Settings")}
                </Button>
              </Card>

              <div className="grid w-full gap-4 sm:gap-[var(--gutterWidth)] md:col-start-1 order-1">
                <Schedule />
              </div>
            </div>
          </div>
        </Fullbody>
      </>
    )
  );
};
